import { render, staticRenderFns } from "./PART_LEGEND.vue?vue&type=template&id=9cc7a646&"
import script from "./PART_LEGEND.vue?vue&type=script&lang=js&"
export * from "./PART_LEGEND.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports